import { Component, Input } from '@angular/core';
import { Project } from '../../../models/projects/project.model';

@Component({
    selector: 'project-skills-interest',
    template: `
        <div class="row">
            <div class="col-12 col-sm-6">
                <div class="card box-shadow">
                    <div class="card-body">
                        <h2 class="h5 primary-1 mb-0">{{ 'projects.pages.details.interests' | translate }}</h2>
                    </div>
                    <ul class="list-group list-group-flush">
                        <li *ngFor="let interest of project.associatedInterests" class="list-group-item">
                            {{ interest.name | wtranslate: 'interests' }}
                        </li>
                    </ul>
                </div>
            </div>

            <div class="col-12 col-sm-6 mt-2 mt-sm-0">
                <div class="card box-shadow">
                    <div class="card-body">
                        <h2 class="h5 primary-1 mb-0">{{ 'projects.pages.details.skills' | translate }}</h2>
                    </div>
                    <ul class="list-group list-group-flush">
                        <li *ngFor="let skill of project.searchedSkills" class="list-group-item">
                            {{ (skill.displayName != null ? skill.displayName : skill.name) | wtranslate: 'skills' }}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    `,
    styles: [
        `
            .list-group {
                width: 100%;
            }
        `,
    ],
})
export class ProjectSkillsInterestComponent {
    @Input() public project: Project;

    constructor() {}
}
